import React from 'react';

import PasswordCondition from '../common/PasswordCondition';
import { useTranslation } from '../../context/TranslationContext';

const PasswordConditionsList = ({ conditions, isFocused }) => {
  const { translate } = useTranslation();

  return (
    <>
      <PasswordCondition
        conditionMet={conditions.length}
        label={translate('authForm.passwordConditions.minCharacters')}
        isFocused={isFocused}
      />
      <PasswordCondition
        conditionMet={conditions.hasNumber}
        label={translate('authForm.passwordConditions.containsNumber')}
        isFocused={isFocused}
      />
      <PasswordCondition
        conditionMet={conditions.hasSpecialChar}
        label={translate('authForm.passwordConditions.containsSpecialChar')}
        isFocused={isFocused}
      />
      <PasswordCondition
        conditionMet={conditions.hasUppercase}
        label={translate('authForm.passwordConditions.containsUppercase')}
        isFocused={isFocused}
      />
      <PasswordCondition
        conditionMet={conditions.hasLowercase}
        label={translate('authForm.passwordConditions.containsLowercase')}
        isFocused={isFocused}
      />
    </>
  );
};

export default PasswordConditionsList;
